import React, { Fragment, memo, useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

import {
  Icon,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Table,
} from "design-react-kit";

import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import DocumentTypeEnum from "../helpers/Enums/DocumentTypeEnum";

function AnalysisPreview({ file, results, documentTypeId }) {
  const [pageNumber, setPageNumber] = useState(1);
  const [pages, setPages] = useState(1);
  const [activeTab, setActiveTab] = useState(
    Number.parseInt(documentTypeId) !== DocumentTypeEnum.F24
      ? "key-value"
      : "text"
  );

  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  useEffect(() => {
    const tabs = document.querySelectorAll(".nav.nav-tabs .nav-item a.active");
    tabs[0]?.classList.add("active-tab");
  }, []);

  useEffect(() => {
    setPageNumber(1);
  }, [file, results]);

  const onDocumentLoad = ({ numPages }) => {
    setPages(numPages);
  };

  const toggleTab = (e, tab) => {
    e.preventDefault();
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
    const tabs = document.querySelectorAll(".nav.nav-tabs .nav-item a.active");
    tabs.forEach((tab) => tab.classList.remove("active-tab"));
    e.target.classList.add("active-tab");
  };

  return (
    <div className="sidebar">
      <div className="pdf ml-5">
        <Fragment>
          {pages > 1 && (
            <div className="mb-4">
              {pageNumber > 1 && (
                <Icon
                  id="prev-page"
                  icon="it-chevron-left"
                  color="info"
                  role="button"
                  onClick={() => {
                    window.scrollTo(0, 0);
                    setPageNumber((prevState) => prevState - 1);
                  }}
                />
              )}
              <span>
                Pagina {pageNumber} of {pages}
              </span>
              {pageNumber < pages && (
                <Icon
                  id="next-page"
                  icon="it-chevron-right"
                  color="info"
                  role="button"
                  onClick={() => {
                    window.scrollTo(0, 0);
                    setPageNumber((prevState) => prevState + 1);
                  }}
                />
              )}
            </div>
          )}
          <Document file={{ data: atob(file) }} onLoadSuccess={onDocumentLoad}>
            <Page pageNumber={pageNumber} renderTextLayer={true} />
          </Document>
          {pages > 1 && (
            <div>
              {pageNumber > 1 && (
                <Icon
                  id="prev-page"
                  icon="it-chevron-left"
                  color="info"
                  role="button"
                  onClick={() => {
                    window.scrollTo(0, 0);
                    setPageNumber((prevState) => prevState - 1);
                  }}
                />
              )}
              <span>
                Pagina {pageNumber} of {pages}
              </span>
              {pageNumber < pages && (
                <Icon
                  id="next-page"
                  icon="it-chevron-right"
                  color="info"
                  role="button"
                  onClick={() => {
                    window.scrollTo(0, 0);
                    setPageNumber((prevState) => prevState + 1);
                  }}
                />
              )}
            </div>
          )}
        </Fragment>
      </div>
      <div className="tabs-wrapper">
        <Nav tabs>
          {Number.parseInt(documentTypeId) !== DocumentTypeEnum.F24 && (
            <NavItem>
              <NavLink
                active={activeTab === "key-value"}
                onClick={(e) => toggleTab(e, "key-value")}
              >
                Fonte da chiavi/valore
              </NavLink>
            </NavItem>
          )}
          <NavItem>
            <NavLink
              active={activeTab === "text"}
              onClick={(e) => toggleTab(e, "text")}
            >
              Fonte testuale
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          {Number.parseInt(documentTypeId) !== DocumentTypeEnum.F24 && (
            <TabPane tabId="key-value" key="key-value">
              <Table bordered>
                <thead className="sticky-top table-head">
                  <tr>
                    <th>Chiave</th>
                    <th>Valore</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(results.jsonKeyValuePairs).map((key, i) => {
                    return (
                      <tr key={`${results.jsonKeyValuePairs[key].Key}-${i}`}>
                        <td>{results.jsonKeyValuePairs[key].Key} </td>
                        <td>{results.jsonKeyValuePairs[key].Value}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </TabPane>
          )}
          <TabPane tabId="text" key="text">
            <textarea
              readOnly
              cols={10}
              rows={50}
              value={results.contentText}
            ></textarea>
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
}

export default memo(AnalysisPreview);
